'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ArrowBack = {};

exports.__exports = ArrowBack;
